/* Clignote : moteur d'affichage 24 × 9 (y = 0 en haut). Pixel allumé = 2 ou 3 (pas de gris visible sur nos lunettes). */
const COLS = 24, ROWS = 9, BLUE = "#3d8bff";

/* Police minuscule sur 6 lignes (bande complète de l'écran), jambages sur une 7e ligne.
   Format : "ligne de départ:rangée|rangée|…", # = LED allumée. */
const RAW = {
  a:"1:.##.|...#|.###|#..#|.###", b:"0:#...|###.|#..#|#..#|#..#|###.", c:"1:.###|#...|#...|#...|.###", d:"0:...#|.###|#..#|#..#|#..#|.###",
  e:"1:.##.|#..#|####|#...|.###", f:"0:..##|.#..|###.|.#..|.#..|.#..", g:"1:.###|#..#|#..#|.###|...#|.##.", h:"0:#...|###.|#..#|#..#|#..#|#..#",
  i:"0:.#.|...|##.|.#.|.#.|###", j:"0:..#|...|.##|..#|..#|..#|##.", k:"0:#...|#..#|#.#.|##..|#.#.|#..#", l:"0:##.|.#.|.#.|.#.|.#.|###",
  m:"1:####.|#.#.#|#.#.#|#.#.#|#.#.#", n:"1:###.|#..#|#..#|#..#|#..#", o:"1:.##.|#..#|#..#|#..#|.##.", p:"1:###.|#..#|#..#|###.|#...|#...",
  q:"1:.###|#..#|#..#|.###|...#|...#", r:"1:#.##|##..|#...|#...|#...", s:"1:.###|#...|.##.|...#|###.", t:"0:.#..|###.|.#..|.#..|.#..|..##",
  u:"1:#..#|#..#|#..#|#..#|.###", v:"1:#...#|#...#|.#.#.|.#.#.|..#..", w:"1:#...#|#...#|#.#.#|#.#.#|.#.#.", x:"1:#...#|.#.#.|..#..|.#.#.|#...#",
  y:"1:#..#|#..#|.##.|..#.|.#..|#...", z:"1:####|..#.|.#..|#...|####",
  "0":"0:.##.|#..#|#..#|#..#|#..#|.##.", "1":"0:.#.|##.|.#.|.#.|.#.|###", "2":"0:.##.|#..#|..#.|.#..|#...|####", "3":"0:###.|...#|.##.|...#|...#|###.",
  "4":"0:#..#|#..#|####|...#|...#|...#", "5":"0:####|#...|###.|...#|#..#|.##.", "6":"0:.##.|#...|###.|#..#|#..#|.##.", "7":"0:####|...#|..#.|.#..|.#..|.#..",
  "8":"0:.##.|#..#|.##.|#..#|#..#|.##.", "9":"0:.##.|#..#|#..#|.###|...#|.##.",
  "!":"0:#|#|#|#|.|#", "?":"0:.##.|#..#|..#.|.#..|....|.#..", ".":"5:#", ",":"5:.#|#.", "'":"0:#|#", ":":"1:#|.|.|#", "-":"3:###", "+":"1:...|.#.|###|.#.",
  "$":"0:.###|#.#.|.###|..##|###.", "♥":"1:.#.#.|#####|#####|.###.|..#..", "*":"1:#.#|.#.|#.#", "/":"0:...#|..#.|..#.|.#..|.#..|#...", " ":"0:.."
};
const FONT = {};
for (const [ch, def] of Object.entries(RAW)) {
  const [top, rows] = def.split(":"); const rs = rows.split("|"); const w = Math.max(...rs.map(r => r.length));
  const cols = new Array(w).fill(0);
  rs.forEach((r, ri) => [...r].forEach((c, x) => { if (c === "#") cols[x] |= 1 << (+top + ri); }));
  FONT[ch] = cols;
}
/* Petite police : 3 colonnes (6 caractères tiennent), 5 lignes, posée lignes 2 à 6. */
const RAW_S = {
  a:".#.|#.#|###|#.#|#.#", b:"##.|#.#|##.|#.#|##.", c:".##|#..|#..|#..|.##", d:"##.|#.#|#.#|#.#|##.", e:"###|#..|##.|#..|###", f:"###|#..|##.|#..|#..",
  g:".##|#..|#.#|#.#|.##", h:"#.#|#.#|###|#.#|#.#", i:"#|#|#|#|#", j:"..#|..#|..#|#.#|.#.", k:"#.#|#.#|##.|#.#|#.#", l:"#..|#..|#..|#..|###",
  m:"#...#|##.##|#.#.#|#...#|#...#", n:"##.|#.#|#.#|#.#|#.#", o:".#.|#.#|#.#|#.#|.#.", p:"##.|#.#|##.|#..|#..", q:".#.|#.#|#.#|##.|.##", r:"##.|#.#|##.|#.#|#.#",
  s:".##|#..|.#.|..#|##.", t:"###|.#.|.#.|.#.|.#.", u:"#.#|#.#|#.#|#.#|###", v:"#.#|#.#|#.#|#.#|.#.", w:"#...#|#...#|#.#.#|##.##|#...#", x:"#.#|#.#|.#.|#.#|#.#",
  y:"#.#|#.#|.#.|.#.|.#.", z:"###|..#|.#.|#..|###",
  "0":"###|#.#|#.#|#.#|###", "1":".#|##|.#|.#|.#", "2":"##.|..#|.#.|#..|###", "3":"##.|..#|.#.|..#|##.", "4":"#.#|#.#|###|..#|..#",
  "5":"###|#..|##.|..#|##.", "6":".##|#..|###|#.#|###", "7":"###|..#|.#.|.#.|.#.", "8":"###|#.#|###|#.#|###", "9":"###|#.#|###|..#|##.",
  "!":"#|#|#|.|#", "?":"##.|..#|.#.|...|.#.", ".":".|.|.|.|#", ",":".|.|.|#|#", "'":"#|#|.|.|.", ":":".|#|.|#|.", "-":"...|...|###|...|...",
  "♥":".#.#.|#####|.###.|..#..|.....", "*":"...|#.#|.#.|#.#|...", "$":".##|##.|.#.|.##|##.", "/":"..#|..#|.#.|#..|#..", " ":"..|..|..|..|.."
};
const FONT_S = {};
for (const [ch, rows] of Object.entries(RAW_S)) {
  const rs = rows.split("|"), w = Math.max(...rs.map(r => r.length)), cols = new Array(w).fill(0);
  rs.forEach((r, ri) => [...r].forEach((c, x) => { if (c === "#") cols[x] |= 1 << ri; }));
  FONT_S[ch] = cols;
}
const clean = s => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
function textCols(str) { const out = []; for (const ch of clean(str)) out.push(...(FONT[ch] || FONT["?"]), 0); out.pop(); return out; }
const textWidth = s => textCols(s).length;
const fits = s => textWidth(s) <= COLS;
function textColsS(str) { const out = []; for (const ch of clean(str)) out.push(...(FONT_S[ch] || FONT_S["?"]), 0); out.pop(); return out; }
const fitsS = s => textColsS(s).length <= COLS;
/* Choix de la police : « grand », « petit », ou « auto » (grand si ça tient, sinon petit). */
function pickFont(str, size) {
  if (size === "petit" || (size !== "grand" && !fits(str) && fitsS(str))) return { cols: textColsS(str), y0: 2, small: true };
  return { cols: textCols(str), y0: 1, small: false };
}
/* Coupe un mot trop long en syllabes, à la française : « bon- / jour », « anni- / versai- / re ». */
function splitWord(w) {
  if (fitsS(w)) return [w];
  const V = /[aeiouy]/, cons = c => c && !V.test(c);
  let best = -1, bs = -1e9;
  for (let i = 2; i <= w.length - 2; i++) {
    if (!fitsS(w.slice(0, i) + "-")) break;
    let sc = -Math.abs(i - w.length / 2) * 0.5 + i * 0.2;
    if (cons(w[i - 1]) && cons(w[i]) && V.test(w[i - 2] || "")) sc += 3;      // VC | CV : bon | jour
    else if (V.test(w[i - 1]) && cons(w[i]) && V.test(w[i + 1] || "")) sc += 2; // V | CV : po | lice
    if (sc > bs) { bs = sc; best = i; }
  }
  if (best < 0) best = Math.max(1, [...w].findIndex((_, i) => !fitsS(w.slice(0, i + 1))));
  return [w.slice(0, best) + "-", ...splitWord(w.slice(best))];
}
/* Mot par mot : chaque mot est affiché seul ; un mot trop long est coupé en morceaux qui tiennent. */
function wordChunks(text, size) {
  const out = [];
  clean(text).split(/\s+/).filter(Boolean).forEach(w => {
    if ((size !== "petit" && fits(w)) || fitsS(w)) { out.push(w); return; }
    out.push(...splitWord(w));
  });
  return out.length ? out : [" "];
}

/* Masque des 200 LED (y écran = 8 − ligne appareil) */
const MASK = new Uint8Array(COLS * ROWS).fill(1);
[[0, 9, 15], [7, 10, 14], [8, 9, 15]].forEach(([y, a, b]) => { for (let x = a; x < b; x++) MASK[y * COLS + x] = 0; });

const draw = (set, pat, x0, y0) => pat.forEach((r, y) => [...r].forEach((c, x) => { if (c === "#") set(x0 + x, y0 + y); }));
const HEART = [".##.##.", "#######", "#######", ".#####.", "..###..", "...#..."], HEART_S = [".#.#.", "#####", ".###.", "..#.."];

function frame(st, t, levels) {
  t = Math.max(0, t || 0);
  const px = new Array(COLS * ROWS).fill(0);
  if (!st) return px;
  const set = (x, y, v = 3) => { x = Math.round(x); y = Math.round(y); if (x >= 0 && x < COLS && y >= 0 && y < ROWS) px[y * COLS + x] = Math.max(px[y * COLS + x], v); };
  if (st.mode === "text" && st.effect === "mots") {
    const chunks = wordChunks(st.text || " ", st.size), per = Math.max(150, (st.perWord || 0.8) * 1000);
    const w = chunks[Math.floor(t / per) % chunks.length], f = pickFont(w, st.size), x0 = Math.floor((COLS - f.cols.length) / 2);
    f.cols.forEach((c, i) => { for (let b = 0; b < 9; b++) if (c >> b & 1) set(x0 + i, b + f.y0); });
  } else if (st.mode === "text") {
    const f = pickFont(st.text || " ", st.size), cols = f.cols, total = cols.length, spd = (st.speed || 5) * 0.0032;
    const scroll = st.effect === "defiler" || total > COLS;
    const off = scroll ? COLS - Math.floor(t * spd) % (total + COLS) : Math.floor((COLS - total) / 2);
    if (st.effect === "clignoter" && Math.floor(t / 400) % 2) return px;
    for (let i = 0; i < total; i++) {
      const x = i + off; if (x < 0 || x >= COLS) continue;
      const wy = st.effect === "vague" ? Math.round(Math.sin(x * 0.6 + t * 0.008)) : 0;
      for (let b = 0; b < 9; b++) if (cols[i] >> b & 1) set(x, b + f.y0 + wy);
    }
  } else if (st.mode === "anim") {
    if (ANIMS[st.id]) ANIMS[st.id].fn(t, set);
  } else if (st.mode === "son") {
    const lv = levels || []; const avg = lv.reduce((a, b) => a + b, 0) / (lv.length || 1);
    for (let x = 0; x < COLS; x++) {
      const v = lv[Math.floor(x / COLS * lv.length)] || 0;
      if (st.style === "barres") { const h = Math.round(v * ROWS); for (let y = ROWS - 1; y >= ROWS - h; y--) set(x, y); }
      else if (st.style === "onde") set(x, 4 + Math.sin(x * 0.7 + t * 0.012) * v * 4.5);
      else { const cx = x < 12 ? 5.5 : 17.5; for (let y = 0; y < ROWS; y++) { const d = Math.hypot(x - cx, (y - 4) * 1.2); if (Math.abs(d - avg * 6.5) < 0.8) set(x, y); } }
    }
  } else if (st.mode === "dessin") {
    (st.px || []).forEach((v, i) => { if (v) px[i] = v; });
  } else if (st.mode === "film") {
    /* v3 : animation image par image, durée propre à chaque image, lecture en boucle (index calculé par coeur.js) */
    const im = st.images || [], k = typeof Coeur !== "undefined" ? Coeur.imageA(st.durees || [], t) : 0;
    (im[k] || []).forEach((v, i) => { if (v) px[i] = v; });
  } else if (st.mode === "soiree") {
    const items = st.items && st.items.length ? st.items : ["bouh"], per = (st.every || 4) * 1000;
    const txt = st.idx != null ? items[((st.idx % items.length) + items.length) % items.length] : items[Math.floor(t / per) % items.length];
    return frame({ mode: "text", text: txt, effect: fits(txt) ? "fixe" : "defiler" }, t % per, levels);
  }
  for (let i = 0; i < px.length; i++) if (!MASK[i]) px[i] = 0;
  return px;
}

/* Rendu sur canvas : la lueur est réservée aux LED. */
function layoutOf(W, H, frameOn) {
  const pad = frameOn ? W * 0.08 : 4;
  const cell = Math.min((W - pad * 2) / COLS, (H - pad * 2) / ROWS);
  return { cell, ox: (W - cell * COLS) / 2, oy: (H - cell * ROWS) / 2 };
}
function drawMatrix(cv, px, opt = {}) {
  const ctx = cv.getContext("2d"), W = cv.width, H = cv.height; ctx.clearRect(0, 0, W, H);
  const { cell, ox, oy } = layoutOf(W, H, opt.frame), lum = opt.lum ?? 1;
  if (opt.frame) {
    ctx.save(); ctx.strokeStyle = "#2b2f38"; ctx.lineWidth = cell * 0.7; ctx.fillStyle = "#0b0c0f";
    const r = cell * 1.6, h = ROWS * cell + cell * 1.2;
    [[0, 12], [12, 12]].forEach(([x, w]) => { ctx.beginPath(); ctx.roundRect(ox + x * cell - cell * 0.6 + (x ? cell * 0.15 : 0), oy - cell * 0.6, w * cell + cell * 1.05, h, [r * 0.5, r * 0.5, r * 2, r * 2]); ctx.fill(); ctx.stroke(); });
    ctx.beginPath(); ctx.moveTo(ox - cell * 0.6, oy + cell); ctx.lineTo(ox - cell * 2.4, oy); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(ox + COLS * cell + cell * 0.6, oy + cell); ctx.lineTo(ox + COLS * cell + cell * 2.4, oy); ctx.stroke();
    ctx.restore();
  }
  for (let y = 0; y < ROWS; y++) for (let x = 0; x < COLS; x++) {
    const i = y * COLS + x; if (!MASK[i]) continue;
    const cx = ox + x * cell + cell / 2, cy = oy + y * cell + cell / 2, v = px[i] | 0;
    ctx.beginPath(); ctx.arc(cx, cy, cell * 0.34, 0, Math.PI * 2);
    if (v >= 2) {
      const a = 0.35 + 0.65 * lum;
      ctx.globalAlpha = a; ctx.fillStyle = BLUE;
      if (!opt.noGlow) { ctx.shadowColor = BLUE; ctx.shadowBlur = cell * 0.7 * lum; }
      ctx.fill(); ctx.shadowBlur = 0; ctx.globalAlpha = 1;
    } else { ctx.fillStyle = "#1a1d24"; ctx.fill(); }
  }
}
